"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.camelize = void 0;
const camelize = (string_) => (string_.replace(/^\w|[A-Z]|(?:(?<![\dA-Za-z])|\B(?!\w))\w/g, (word, index) => index === 0 ? word.toLowerCase() : word.toUpperCase()).replace(/[\s+._|]/g, ''));
exports.camelize = camelize;
//# sourceMappingURL=camelize.js.map